
(function(){
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  var HANDLE = m ? m[1] : 'purrycraft';
  function status(msg){
    var el = document.querySelector('.buy-status');
    if(el) el.textContent = msg;
  }
  function add(btn){
    var label = btn.innerHTML;
    btn.setAttribute('aria-busy','true');
    fetch('/products/' + HANDLE + '.js', {credentials:'same-origin'})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(p){
        var v = p.variants.filter(function(x){return x.available;})[0] || p.variants[0];
        if(!v) throw 0;
        return fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:v.id, quantity:1}]})});
      })
      .then(function(r){ if(!r.ok) throw 0; window.location.href = '/cart'; })
      .catch(function(){
        btn.removeAttribute('aria-busy');
        btn.innerHTML = label;
        status('Open this page in the store to add the pattern to your cart.');
      });
  }
  document.querySelectorAll('[data-buy]').forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); add(btn); });
  });
})();

(function(){
  var KEY = 'pcf_deal_ends', DAY = 864e5, ends;
  try { ends = parseInt(localStorage.getItem(KEY), 10); } catch (e) { ends = 0; }
  if (!ends || isNaN(ends) || ends < Date.now() || ends > Date.now() + DAY) {
    ends = Date.now() + DAY;
    try { localStorage.setItem(KEY, String(ends)); } catch (e) {}
  }
  var pad = function(n){ return (n < 10 ? '0' : '') + n; };
  var hs = document.querySelectorAll('[data-h]'), ms = document.querySelectorAll('[data-m]'),
      ss = document.querySelectorAll('[data-s]'), ticks = document.querySelectorAll('[data-tick]');
  var exp = document.querySelector('[data-expires]');
  if (exp) {
    var d = new Date(ends), h = d.getHours(), ap = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12;
    exp.textContent = (d.getDate() === new Date().getDate() ? 'today' : 'tomorrow') + ' at ' + h + ':' + pad(d.getMinutes()) + ' ' + ap;
  }
  function tick(){
    var left = Math.max(0, ends - Date.now());
    if (left === 0) { ends = Date.now() + DAY; try { localStorage.setItem(KEY, String(ends)); } catch (e) {} left = DAY; }
    var s = Math.floor(left / 1000), hh = Math.floor(s / 3600), mm = Math.floor(s % 3600 / 60), sc = s % 60;
    var set = function(list, v){ for (var i = 0; i < list.length; i++) list[i].textContent = pad(v); };
    set(hs, hh); set(ms, mm); set(ss, sc);
    var t = pad(hh) + ':' + pad(mm) + ':' + pad(sc);
    for (var i = 0; i < ticks.length; i++) ticks[i].textContent = t;
  }
  tick(); setInterval(tick, 1000);
})();
